import { useParams } from "react-router-dom";
import { DocsWikiLayout } from "../components/DocsWikiLayout";

export default function DocArticle() {
  const { slug = "" } = useParams<{ slug: string }>();
  return <DocsWikiLayout slug={slug} />;
}
